<template>
  <v-data-iterator
    :items="transactions.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="transactions.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-transaction-card v-for="(transaction, index) in slot.items"
        :transaction="transaction"
        :key="index"
        @edit="$emit('edit', transaction)"
      />
    </template>
  </v-data-iterator>
</template>


<script>

  export default {

    components: {
      'im-transaction-card': () => import('@/components/Transaction/TransactionCard')
    },

    props: {
      transactions: Object
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 10,
      },
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    computed: {
      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },
      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }
    },
  }

</script>